<template>
	<div>
		<div class="text-right md:flex md:justify-between md:align-items-center">
			<EbHeading v-if="!isMobile && !isSmallScreen" level="h1" class="eb-page-heading">Mes disponibilités</EbHeading>
			<a :href="publicProfileUrl" class="eb-button secondary small icon-after" target="_blank" rel="noreferrer noopener" title="Voir ma fiche en ligne - Nouvelle fenêtre">Voir ma fiche en ligne <font-awesome-icon :icon="['fas', 'external-link-alt']" /></a>	
		</div>
		
		<div class="eb-content-default md:grid md:grid-cols-2 md:gap-x-36">
			<div>
				<EbHeading level="h2" class="eb-box-heading">Mes disponibilités actuelles</EbHeading>
				
				<EbBanner :isActive="isBannerActuelleActive" :type="bannerActuelleType" :timestamp="bannerActuelleTimestamp">{{bannerActuelleContent}}</EbBanner>
				
				<form action="#" v-if="dispoActuelle" @submit.prevent="setDispoActuelle()">
					
					<EbDisclosure v-model="dispoActuelle.dispoActuelle" @input="resetAllActual()" label="J'ai de la disponibilité actuellement" isSwitch groupTag="fieldset" legend="Nombre(s) de places pour accueillir des enfants :">
						<EbInput v-for="d in dispoActuelleArray" :key="d" min="0" type="number" inline required :label="dispoActuelle.disposTranchesAgeSolis[d].libelleTrancheAgeSolis" v-model.number="dispoActuelle.disposTranchesAgeSolis[d].nombrePlaces"></EbInput>
						
						<EbTextarea label="Précisions sur les disponibilités actuelles (jours, horaires…)" v-model="dispoActuelle.precisions" remainCharacters maxcharacter.number="200"></EbTextarea>
						
						<EbCheckbox v-model="dispoActuelle.dispoPeriscolaire" label="J’ai des disponibilités pour du périscolaire"></EbCheckbox>
						<EbCheckbox v-model="dispoActuelle.dispoVacancesScolaires" label="J’ai des disponibilités pour les vacances scolaires"></EbCheckbox>
					</EbDisclosure>
					
					<div class="eb-button-group">
						<EbButton type="submit">Enregistrer</EbButton>
					</div>
				</form>
			</div>
			
			<div>
				<EbHeading level="h2" class="eb-box-heading">Mes disponibilités futures</EbHeading>
				
				<EbBanner :isActive="isBannerFutureActive" :type="bannerFutureType" :timestamp="bannerFutureTimestamp">{{bannerFutureContent}}</EbBanner>
				
				<div class="eb-button-group">
					<EbLinkButton :to="{name: 'dispofuture'}" class="small secondary icon-after">Ajouter une disponibilité future<font-awesome-icon :icon="['fas', 'plus']"/></EbLinkButton>
				</div>
				
				<ul class="eb-list">					
					<dispoFuture v-for="dispo in disposFutures" :key="dispo.id" :dispo="dispo" @deleteFutureDispo="deleteFutureDispo"></dispoFuture>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import dispoFuture from '@/components/dispoFuture.vue'

export default {
	name: "dispos",
	components: {
		dispoFuture
	},
	props: {
		status: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			dispoActuelle: null,
			disposFutures: null,
			publicProfileUrl: '',
			
			isBannerActuelleActive: false,
			bannerActuelleTimestamp: '',
			bannerActuelleType: null,
			bannerActuelleContent: '',
			
			isBannerFutureActive: false,
			bannerFutureTimestamp: '',
			bannerFutureType: null,
			bannerFutureContent: ''
		}
	},
	computed: {
		dispoActuelleArray: function() {
			return [...new Array(this.dispoActuelle.disposTranchesAgeSolis.length).keys()]
		}
	},
	mounted() {
		this.getDisponibilites()
		this.publicProfileUrl = this.getPublicProfileLink()
		
		if(this.status !== '') {
			this.isBannerFutureActive = true
			this.bannerFutureType = "success"
			this.bannerFutureTimestamp = this.getTime()
			switch (this.status) {
				case 'create':
				this.bannerFutureContent = 'L’enregistrement de la disponibilité future a bien été pris en compte.'
				break;
				case 'update':
				this.bannerFutureContent = 'La modification de la disponibilité future a bien été prise en compte.'
				break;
				case 'delete':
				this.bannerFutureContent = 'La suppression de la disponibilité future a bien été prise en compte.'
				break;
			}
		}
	},
	methods: {
		resetAllActual: function() {
			this.dispoActuelle.dispoPeriscolaire = false
			this.dispoActuelle.dispoVacancesScolaires = false
			
			this.dispoActuelle.disposTranchesAgeSolis.forEach(d => {
				d.nombrePlaces = 0
			})
		},
		getDisponibilites: async function() {
			this.isBannerActuelleActive = false
			
			await this.$http
			.get("assmat/disponibilites")
			.then(resp => {
				this.dispoActuelle = resp.data.dispoActuelle
				this.disposFutures = resp.data.disposFutures
			})
			.catch(error => {
				this.isBannerActuelleActive = true
				this.bannerActuelleTimestamp = this.getTime()
				this.bannerActuelleType = 'error'
				this.bannerActuelleContent = 'Une erreur est survenue, veuillez réessayer ultérieurement.'
			})
		},
		setDispoActuelle: async function() {
			this.isBannerActuelleActive = false
			this.bannerActuelleTimestamp = this.getTime()
			
			await this.$http
			.put("assmat/disponibiliteActuelle", this.dispoActuelle)
			.then(resp => {
				this.isBannerActuelleActive = true
				this.bannerActuelleType = 'success'
				this.bannerActuelleContent = 'Vos modifications de disponibilités actuelles ont bien été sauvegardées.'
			})
			.catch(error => {
				this.isBannerActuelleActive = true
				this.bannerActuelleType = 'error'
				this.bannerActuelleContent = 'Une erreur est survenue, veuillez vérifier votre saisie.'
			})
		},
		deleteFutureDispo: async function(idDispo) {
			this.isBannerFutureActive = false
			this.bannerFutureTimestamp = this.getTime()
			
			await this.$http
			.delete(`assmat/disponibilitesFutures/${idDispo}`)
			.then(resp => {
				this.isBannerFutureActive = true
				this.bannerFutureType = 'success'
				this.bannerFutureContent = 'La suppression de la disponibilité future a bien été prise en compte.'
				
				this.disposFutures = this.disposFutures.filter(el => {
					return el.id !== idDispo
				})
			})
			.catch(error => {
				this.isBannerFutureActive = true
				this.bannerFutureType = 'error'
				this.bannerFutureContent = 'Une erreur est survenue, veuillez réessayer ultérieurement.'
			})
		},
	},
}
</script>
